import { CampaignsShow } from '@Resources/campaigns/CampaignsShow';
import { ResourceDefinition } from '@Utils/types';

export const campaignsResource: ResourceDefinition = {
  options: { label: 'menu.campaigns' },
  show: (props) => <CampaignsShow {...props} />,
};
